import { InjectionToken } from '@angular/core';

export const CONTROL_ERRORS = new InjectionToken<Record<string, string>>(
  'CONTROL_ERRORS'
);
